<template>
  <div>
    <nav class="nav navbar bg-white px-2" :class="navRelative ? 'mb-2' : 'fixed-top'">
      <div class="nav-item">
        <button @click.prevent="$router.back()" class="btn btn-outline">
          <i class="fas fa-chevron-left"></i></button>
      </div>
      <div class="navbar-brand text-truncate flex-fill mb-0"><b>{{ channel.display_name || '' }}</b></div>
      <div v-if="channelId" class="nav-item flex-shrink-0 position-relative">
        <button @click.prevent="menuOpen = !menuOpen" class="btn btn-outline-secondary btn-sm">
          <i class="fas fa-ellipsis-v"></i>
        </button>
        <div v-if="menuOpen" class="dropdown-menu show" style="position:absolute; right:0; left:auto; z-index:1056;">
          <button class="dropdown-item" @click.prevent="showInfo = !showInfo; menuOpen = false">
            <i class="fas fa-info-circle me-1"></i> Channel-Info
          </button>
          <button v-if="channel.channel_type === 'P' && channel.name !== 'town-square'"
           class="dropdown-item text-danger"
           @click.prevent="leaveChannel">
            <i class="fas fa-sign-out-alt me-1"></i> Channel verlassen
          </button>
        </div>
      </div>
    </nav>
    <channel-info-modal :visible="showInfo" :channel="channel"
      @close="showInfo = false" @leave="leaveChannel" />
    <!-- Embedded (navRelative): the card is the positioning context for the
         absolutely placed composer and c-chat-content bounds the scroll area
         (same pattern as talk-detail-page). Standalone: fixed navbar + fixed
         composer, so py-5 keeps the content clear of both. -->
    <div v-if="channelId" :class="navRelative ? 'card' : 'container-fluid mt-2 py-5'">
      <div :class="{'card-body c-chat-content': navRelative}">
        <channel :channelId="channelId" :nav-relative="navRelative"
                 :read-only="channel.can_post === false"></channel>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Channel from '@/components/channel/channel.vue'
import ChannelInfoModal from '@/components/channel/channel-info-modal.vue'

export default {
  name: 'ChannelView',
  components: {
    Channel,
    ChannelInfoModal,
  },
  props: {
      channelName: {type: String, required: true},
      // True when embedded in a CMS page: the view then lays itself out in the
      // document flow instead of relying on a full-viewport SPA screen.
      navRelative: {type: Boolean, default: false},
  },
  data() {
    return {
      channelId: '',
      channel: {},
      menuOpen: false,
      showInfo: false,
    }
  },
  computed: {
  },
  created() {
    if (navigator.onLine) this.fetchChannel()
  },
  methods: {
    leaveChannel() {
      this.menuOpen = false
      if (!confirm(`${this.channel.display_name} verlassen?`)) return
      let me = this
      this.$chat.delete(`channels/${this.channelId}/members/`).then(() => {
        me.$router.back()
      })
    },
    fetchChannel() {
      let me = this
      this.$chat.get('channels/').then(response => {
        let channels = response.data.results || response.data
        me.channel = channels.filter(channel => channel.name == me.channelName)[0]
        if (me.channel)
          me.channelId = me.channel.id
      })
    }
  }
}
</script>

<style scoped>
/* Bounded, scrollable message area for the embedded (navRelative) case; the
   padding reserves the strip the absolutely placed composer sits on. */
.c-chat-content {
  height: 60vh;
  overflow-y: auto;
  padding-bottom: 3rem;
}
</style>
